import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import ConfirmationDialog from '~components/Dialog/ConfirmationDialog';
import { AddOnCharge } from '~hooks/useAddOns/models';

interface RemoveAddOnChargeDialogProps {
  addOnCharge: AddOnCharge | null;
  isBusy: boolean;
  onClose: () => void;
  onConfirm: () => void;
  settlementName: string;
  voidsSettlement: boolean;
}

export default function RemoveAddOnChargeDialog({
  addOnCharge,
  isBusy,
  onClose,
  onConfirm,
  settlementName,
  voidsSettlement,
}: RemoveAddOnChargeDialogProps) {
  return (
    <ConfirmationDialog
      confirmButtonProps={{
        children: t('approvals.driver_pay.settlements.sheet.remove_add_on.confirm'),
      }}
      isBusy={isBusy}
      isOpen={addOnCharge !== null}
      onClose={onClose}
      onConfirm={onConfirm}
      title={t('approvals.driver_pay.settlements.sheet.remove_add_on.title', {
        settlementId: settlementName,
      })}
    >
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
        {t('approvals.driver_pay.settlements.sheet.remove_add_on.description')}
      </Typography>
      {voidsSettlement && (
        <Alert severity="warning">
          {t('approvals.driver_pay.settlements.sheet.remove_add_on.voids_settlement', {
            settlementId: settlementName,
          })}
        </Alert>
      )}
    </ConfirmationDialog>
  );
}
